<template>
  <p>
    <AnnotationLabel :isIntro="isIntro" :stateAnnotations="stateAnnotations" :latestDistrictCode="latestDistrictCode" :numDistricts="numDistricts" :totalTimelineSpan="totalTimelineSpan" />
    <span v-if="summaryText" class="text">{{ summaryText }}</span>
  </p>
</template>

<script>
import AnnotationLabel from './AnnotationLabel';

export default {
  name: 'AnnotationSummary',
  components: {
    AnnotationLabel
  },
  props: ['isIntro', 'stateAnnotations', 'latestDistrictCode', 'numDistricts', 'totalTimelineSpan'],
  computed: {
    summaryText () {
      if (!this.stateAnnotations) return null;
      let summary_text = '';

      if (this.numDistricts > 1) {
        const today = new Date().getFullYear();
        summary_text += ` ${this.numberAsWrittenText(this.numDistricts-1, true)} other `;
        summary_text += `${this.numDistricts > 2 ? 'districts have' : 'district has'} served this area `;
        summary_text += this.totalTimelineSpan.end == today ? `since ${this.totalTimelineSpan.start}.` : `between ${this.totalTimelineSpan.start} and ${this.totalTimelineSpan.end}.`;
      } else {
        summary_text += `Unlike in most states which are divided into multiple electoral districts, it covers the entire ${this.stateAnnotations.admin_type}.`;
      }

      return summary_text;
    }
  },
  methods: {
    numberAsWrittenText (i, capitalized = false) {
      const decimalsLower = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen'];
      const decimalsUpper = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen'];
      if (i > 0 && i < 16) {
        return capitalized ? decimalsUpper[i-1] : decimalsLower[i-1];
      }
      return i;
    }
  }
}
</script>

<style lang="scss" scoped>
.mq-mobile {
  p {
      margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AnnotationSummary.vue